
const dashboard = () => import('../views/experiment/dashboard.vue')
const experimentList = () => import('../views/experiment/experiments/index.vue')
const experimentNew = () => import('../views/experiment/experiments/new.vue')
const experimentDetail = () => import('../views/experiment/experiments/show.vue')

export default [
    {
        path: '/experiment/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'experiment',
        }
    },
    {
        path: "/experiment/experiments", component: experimentList, meta: {
            module_name: 'experiment',
            en_name: "experimentExperiment",
            auth_id: 91100
        }
    },
    {
        path: "/experiment/experiments/new", component: experimentNew, meta: {
            module_name: 'experiment',
            en_name: "experimentExperiment",
            auth_id: 91101
        }
    },
    {
        path: "/experiment/experiments/:id/edit", component: experimentNew, meta: {
            module_name: 'experiment',
            en_name: "experimentExperiment",
            auth_id: 91103
        }
    },
    {
        path: "/experiment/experiments/:id", component: experimentDetail, meta: {
            module_name: 'experiment',
            en_name: "experimentExperiment",
            auth_id: 91102
        }
    },
]
